import { eEstadoMaestro } from "../common/enumModel";
import { IActoCondicionModel } from "../interfaces/acto-condicion/IActoCondicionModel";

export class ActoCondicionModel implements IActoCondicionModel {
    
    idActoCondicion : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idActoCondicion = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}